module.exports = __webpack_public_path__ + "img/web-application.27adf15c.png";